export default __webpack_public_path__ + "static/remotecustomerhero-3e7f4ee9b67e4c94d89924b96cb00e98.webp";